import Chainable from "./Chainable.mts";
import SyncContext from "./SyncContext.mts";

export default class Cleanup {
  protected static context = new SyncContext<Cleanup | undefined>(undefined);

  static current() {
    return Cleanup.context.current();
  }

  disposed = false;
  protected cleanups: (() => void)[] = [];

  constructor() {
    Cleanup.current()?.add(this.dispose);
  }

  collect = Chainable.create(
    Chainable.wrapFactory(({ patchSchedulers = false }) => (fn: () => void) => {
      if (patchSchedulers) {
        globalThis.setTimeout = this.setTimeout as unknown as typeof setTimeout;
        globalThis.setInterval = this
          .setInterval as unknown as typeof setInterval;

        Cleanup.context.run(this, fn);

        globalThis.setTimeout = this.setTimeout
          .original as unknown as typeof setTimeout;
        globalThis.setInterval = this.setInterval
          .original as typeof setInterval;
      } else Cleanup.context.run(this, fn);

      return this;
    }),
    { patchSchedulers: { patchSchedulers: true } }
  );

  setTimeout = Object.assign(
    ((fn, timeout) => {
      if (this.disposed) return;
      const timeoutId = setTimeout(fn, timeout);
      this.add(() => clearTimeout(timeoutId));
      return timeoutId;
    }) as typeof setTimeout<any[]>,
    { original: setTimeout }
  );

  setInterval = Object.assign(
    ((fn, interval) => {
      if (this.disposed) return;
      const intervalId = setInterval(fn, interval);
      this.add(() => clearInterval(intervalId));
      return intervalId;
    }) as typeof setInterval<any[]>,
    { original: setInterval }
  );

  add = (...cleanups: (() => void)[]) => {
    if (this.disposed)
      for (const cleanup of cleanups) {
        cleanup();
      }
    else this.cleanups.push(...cleanups);
  };

  dispose = () => {
    if (this.disposed) return;
    this.disposed = true;
    for (const cleanup of this.cleanups) {
      cleanup();
    }
  };
}
